export default __webpack_public_path__ + "static/media/logo 3.224acb44.svg";